import script from "./errorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./errorModal.vue?vue&type=script&setup=true&lang=js"

import "./errorModal.vue?vue&type=style&index=0&id=9a4ab9f4&lang=css"

const __exports__ = script;

export default __exports__